var map = {
	"./Admin-Controls.ts": 8632,
	"./Claim-Best.js": 3798,
	"./Diplomacy-Ambassador.js": 4854,
	"./Map-Filter-Export.js": 3175,
	"./Remote-Explorer.ts": 3569,
	"./Repeat-Attack.js": 6362,
	"./Score-Board-Dist-To-Center.js": 4892,
	"./Score-Board-LootSilver.js": 4128,
	"./Towards-Center.js": 1442,
	"./Voyage-Time.js": 7986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7480;